var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('article', [_c('activity-stage', {
    attrs: {
      "customRootContainerClass": ("" + (_vm.isMobile || _vm.keyboardEnabled ? '' : 'full-height'))
    }
  }, [_c('template', {
    slot: "instructions"
  }, [_vm._t("instructions")], 2), _c('activity-wrapper', {
    staticClass: "drag-and-drop-categories",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [!_vm.shouldShowKeyboard ? _c('section', {
    attrs: {
      "id": "questionSection"
    }
  }, [_vm.currentRound.dynamicContent ? _c('dynamic-content', {
    attrs: {
      "dynamicContent": _vm.currentRound.dynamicContent
    }
  }) : _vm._e()], 1) : _vm._e(), !_vm.shouldShowKeyboard ? _c('section', {
    attrs: {
      "id": "dragAndDropSection"
    }
  }, [_c('div', {
    staticClass: "draggableArea"
  }, [_c('div', {
    staticClass: "draggableBankArea",
    attrs: {
      "aria-label": _vm.getDragAreaAriaLabel()
    },
    on: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleDragContainerEnterEvent();
      }
    }
  }, _vm._l(_vm.currentRound.draggableItems, function (item) {
    var _item$image, _item$image$image, _item$image$image$src, _item$image2, _item$image2$image, _item$image$image$des, _item$image3, _item$image3$image;
    return _c('div', {
      key: item.id,
      staticClass: "bankAreaItem startingPoint",
      style: {
        height: _vm.imageHeight.drag
      },
      attrs: {
        "id": ("startingPoint-" + (item.id))
      }
    }, [_c('div', {
      staticClass: "draggableItem",
      class: ['draggableItem', {
        'element-selected': _vm.isElementSelected(item)
      }],
      attrs: {
        "id": ("draggable-" + (item.id)),
        "data-id": ("" + (item.id)),
        "tabindex": _vm.isGuessed(item) ? 11 : 10,
        "role": "button",
        "aria-label": ((_vm.isElementSelected(item) ? 'Selected: ' : '') + " " + ((_item$image = item.image) === null || _item$image === void 0 ? void 0 : (_item$image$image = _item$image.image) === null || _item$image$image === void 0 ? void 0 : _item$image$image.description))
      },
      on: {
        "keyup": function ($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.handleOnDraggableItemEnterEvent(item.id, true);
        }
      }
    }, [_c('div', {
      staticClass: "dragAndDropContent"
    }, [_c('img', {
      staticClass: "draggable-image",
      attrs: {
        "src": (_item$image$image$src = (_item$image2 = item.image) === null || _item$image2 === void 0 ? void 0 : (_item$image2$image = _item$image2.image) === null || _item$image2$image === void 0 ? void 0 : _item$image2$image.src) !== null && _item$image$image$src !== void 0 ? _item$image$image$src : '',
        "alt": (_item$image$image$des = (_item$image3 = item.image) === null || _item$image3 === void 0 ? void 0 : (_item$image3$image = _item$image3.image) === null || _item$image3$image === void 0 ? void 0 : _item$image3$image.description) !== null && _item$image$image$des !== void 0 ? _item$image$image$des : ''
      }
    })])])]);
  }), 0)]), _c('div', {
    staticClass: "droppableArea"
  }, _vm._l(_vm.currentRound.dropZones, function (item) {
    return _c('div', {
      key: item.id,
      class: ['dropItemContainer'],
      attrs: {
        "id": ("" + (item.id))
      }
    }, [_c('div', {
      staticClass: "titleText",
      attrs: {
        "id": ("titleText-" + (item.id))
      }
    }, [_c('html-renderer', {
      attrs: {
        "htmlObject": item.titleHtml
      }
    }), _c('div', {
      staticClass: "feedbackContainer"
    }, [_vm.shouldShowIcon(item, true) ? _c('CorrectIcon', {
      attrs: {
        "height": "100%",
        "width": "100%"
      }
    }) : _vm._e(), _vm.shouldShowIcon(item, false) ? _c('WrongIcon', {
      attrs: {
        "height": "100%",
        "width": "100%"
      }
    }) : _vm._e()], 1)], 1), _c('div', {
      class: ['category', 'focusable', {
        'selectable-answer': !!_vm.selectedElement
      }],
      style: _vm.getCategoryBorder(item),
      attrs: {
        "id": ("dropArea-" + (item.id)),
        "tabIndex": "10"
      },
      on: {
        "keyup": function ($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.handleOnDroppableItemEnterEvent(item.id, true);
        }
      }
    }, [item.fixedItems ? _c('div', {
      attrs: {
        "id": "fixedItem-wrapper"
      }
    }, _vm._l(item.fixedItems, function (fixedItem) {
      var _fixedItem$image$imag, _fixedItem$image, _fixedItem$image$imag2;
      return _c('div', {
        key: fixedItem.id,
        staticClass: "fixedItem",
        style: {
          height: _vm.imageHeight.drop
        }
      }, [_c('img', {
        staticClass: "draggable-image",
        attrs: {
          "src": (_fixedItem$image$imag = (_fixedItem$image = fixedItem.image) === null || _fixedItem$image === void 0 ? void 0 : (_fixedItem$image$imag2 = _fixedItem$image.image) === null || _fixedItem$image$imag2 === void 0 ? void 0 : _fixedItem$image$imag2.src) !== null && _fixedItem$image$imag !== void 0 ? _fixedItem$image$imag : '',
          "alt": ""
        }
      })]);
    }), 0) : _vm._e()])]);
  }), 0)]) : _vm._e(), _vm.shouldShowKeyboard ? _c('div', {
    attrs: {
      "id": "textContainer"
    }
  }, [_c('div', {
    attrs: {
      "id": "steps"
    }
  }, [_c('html-renderer', {
    attrs: {
      "htmlObject": _vm.currentRound.typeOverText && _vm.currentRound.typeOverText.directionsHtml
    }
  }), _c('text-display-list', {
    attrs: {
      "id": "input",
      "text-size": "medium-large"
    }
  }, [_c('blinking-cursor-text', {
    attrs: {
      "text": _vm.currentRound.typeOverText && _vm.currentRound.typeOverText.text,
      "text-step": 0
    }
  })], 1)], 1)]) : _vm._e()])], 2), _c('article', {
    style: {
      display: _vm.keyboardEnabled ? 'block' : 'none'
    }
  }, [_vm._t("keyboard")], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }